
        import 'Billing.63bd459.css-module'
        export default {"downloadColumn":"downloadColumn_Billing_63bd459","redHighlight":"redHighlight_Billing_63bd459"}
    